var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[_c('use',{attrs:{"href":require("@/assets/img/icons.svg") + "#","xlink:href":require("@/assets/img/icons.svg") + "#"}})])}
var staticRenderFns = []

export { render, staticRenderFns }